import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actionType } from 'utils/constants';

import utils from 'utils';
import actions from 'state/actions';
import selectors from 'state/selectors';

import CommonButton from 'components/Buttons/CommonButton';

const EditUser = () => {
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const selectedUser = useSelector(selectors.configurator.getSelectedUser);

  return (
    <CommonButton
      id="edit-user-btn"
      action={() => dispatch(actions.configurator.setFormMode('edit'))}
      disabled={!(selectedUser && utils.user.isActionByCompanyActive(actionType.EDIT_USER))}
      scope="tertiary"
      value={t('edit-user')}
      customIcon="pen"
    />
  );
};

export default EditUser;
